import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import VueAnimateNumber from 'vue-animate-number'
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate'
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker'
import Vue2Editor from "vue2-editor"
import Fragment from 'vue-fragment'

// COMPONENTS //
import PerformanceBoxComponent from '@/components/tools/PerformanceBoxComponent.vue'
import ClickAndCollectBoxComponent from '@/components/tools/ClickAndCollectBox.vue'
import PaymentStoresBoxComponent from '@/components/tools/PaymentStoresBoxComponent.vue'
import Pagination from '@/components/tools/PaginationComponent'
import ChartPagination from '@/components/tools/ChartPaginationComponent'
import LabelHistory from '@/components/tools/LabelHistory'
import StoreHistory from '@/components/tools/StoreHistory'
import OrdersTable from '@/components/tools/Tables/OrdersTable'
import ClickCollectTable from '@/components/tools/Tables/ClickCollectTableComponent'
import OrderNotes from '@/components/tools/OrderNotes'
import EditAddressModal from '@/components/tools/Modals/EditAddressModal'
import PriceInfoModal from '@/components/tools/Modals/PriceInfoModal'
import CancelModal from '@/components/tools/Modals/CancelModal'
import ReturnModal from '@/components/tools/Modals/ReturnModal'
import RankingModal from '@/components/tools/Modals/RankingModal'
import SupportModal from '@/components/tools/Modals/SupportModal'
import RefundModal from '@/components/tools/Modals/RefundModal'
import RefundModal2 from '@/components/tools/Modals/RefundModal2'
import RefundModal3 from '@/components/tools/Modals/RefundModal3'
import AvisCreationModal from '@/components/tools/Modals/AvisCreationModal'
import EditCompany from '@/components/tools/CompanyEdit'
import StoresTable from '@/components/tools/Tables/StoresTable'
import UsersTable from '@/components/tools/Tables/UsersTable'
import ErpExtension from '@/components/tools/ErpExtensionComponent'
import StoreCreate from '@/components/tools/StoreCreate'
import StoreEdit from '@/components/tools/StoreEdit'
import LineChart from '@/components/tools/Charts/LineChart'
import TopBrandsChart from '@/components/tools/Charts/TopBrandsChart'
import TopCategoriesChart from '@/components/tools/Charts/TopCategories'
import TopColorsChart from '@/components/tools/Charts/TopColors'
import TopPricesChart from '@/components/tools/Charts/TopPrices'
import TopProductsChart from '@/components/tools/Charts/TopProducts'
import TopSeasonsChart from '@/components/tools/Charts/TopSeasons'
import AvgSellingPriceBarChart from "./components/tools/Charts/AvgSellingPriceBarChart"
import ReturnByBrandsChart from "./components/tools/Charts/ReturnByBrandsChart"
import ReturnReasonsChart from "./components/tools/Charts/ReturnReasons"
import CategoriesStatsChart from "./components/tools/Charts/CategorieStatsChart"
import BrandsStatsChart from "./components/tools/Charts/BrandsStatsChart"
import ProductsStatsChart from "./components/tools/Charts/ProductsStatsChart"
import SlowestShippedToDelivered from "./components/tools/Charts/SlowestShippedToDelivered"
import SumSellingPrice from "./components/tools/Charts/SumSellingPrice"
import PriceBarChart from '@/components/tools/Charts/AvgSellingPriceBarChart'
import DoughnutChart from '@/components/tools/Charts/DoughnutChart'
import MultipleLineChart from '@/components/tools/Charts/MultipleLineChart'
import SalesReport from '@/components/tools/SalesReport'
import StatsReport from '@/components/tools/StatisticsReport'
import PriceBox from '@/components/tools/PriceBoxComponent'
import StatsDescription from '@/components/tools/StatsDescriptionBox'
import SalesReportChart from '@/components/tools/Charts/SalesReportChart'
import MarketplaceStats from '@/components/tools/MarketplaceStats'
import ERPExtension from '@/components/tools/ErpExtensionComponent'
import DateRangePicker from '@/components/tools/DateRangePicker.vue'
import BulkUpdateModal from '@/components/tools/Modals/BulkUpdateModal'
import SapDocHistoryModal from '@/components/tools/Modals/SapDocHistoryModal'
import MonitoringRow from '@/components/tools/TableRows/MonitoringRow'
import LabelRow from '@/components/tools/TableRows/LabelRow'
import ProductRow from '@/components/tools/TableRows/ProductRow'
import PaymentHistory from '@/components/tools/PaymentHistory'
import SapSalesChannelConfigModal from '@/components/tools/Modals/SapSalesChannelConfigModal'
import PriceBoxMpComponent from '@/components/tools/PriceBoxMpComponent'
import StoreRow from '@/components/tools/TableRows/storeRow'
import TimeTabs from '@/components/tools/TimeTabs'
import ChannelsfFilter from "@/components/tools/ChannelsfFilter";
// FILTERS //
import { dateMonth, domain, count, prettyDate, pluralize, capitalize, currency, translate, dateFormat, toUpper, orderDate, orderDateApi, orderTitle, country, percentage } from './filters'
API.defaults.baseURL = getURI()
API.defaults.headers.common['Content-Type'] = 'application/json'
API.interceptors.request.use(config => {
  let parsedUrl = config.url.split('?')[1]
  if (typeof parsedUrl !== 'undefined') {
    let splitParams = parsedUrl.split('&')
    for (let u in splitParams){
      let splitted = splitParams[u].split('=')
      let encoded = encodeURIComponent(splitted[1])
      splitParams[u] = [splitted[0], encoded].join('=')
    }
    config.url = `${config.url.split('?')[0]}?${splitParams.join('&')}`
  }
  if (config.url.match(/login.*/)) {
    return config
  }
  if (store.getters.loggedInStatus) {
    config.headers.common['auth-token'] = store.getters.token
    return config
  }
  router.push('/')
}, error => {
  console.log(error)
})
API.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response && error.response.status === 401) {
    store.commit('updateLoggedInStatus', false)
    store.dispatch('logout')
  }
  return Promise.reject(error)
})
Validator.extend('refund', (value, [otherValue]) => {
 return value <= otherValue
});
Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('dateMonth', dateMonth)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)
Vue.filter('capitalize', capitalize)
Vue.filter('currency', currency)
Vue.filter('translate', translate)
Vue.filter('dateFormat', dateFormat)
Vue.filter('toUpper', toUpper)
Vue.filter('orderDate', orderDate)
Vue.filter('orderDateApi', orderDateApi)
Vue.filter('orderTitle', orderTitle)
Vue.filter('country', country)
Vue.filter('percentage', percentage)
Vue.component('AvgSellingPriceBarChart', AvgSellingPriceBarChart)
Vue.component('ReturnByBrandsChart', ReturnByBrandsChart)
Vue.component('ReturnReasonsChart', ReturnReasonsChart)
Vue.component('CategoriesStatsChart', CategoriesStatsChart)
Vue.component('BrandsStatsChart', BrandsStatsChart)
Vue.component('ProductsStatsChart', ProductsStatsChart)
Vue.component('SlowestShippedToDelivered', SlowestShippedToDelivered)
Vue.component('SumSellingPrice', SumSellingPrice)
Vue.component('myPagination', Pagination)
Vue.component('Datepicker', Datepicker)
Vue.component('chartPagination', ChartPagination)
Vue.component('cancelModal', CancelModal)
Vue.component('returnModal', ReturnModal)
Vue.component('rankingModal', RankingModal)
Vue.component('supportModal', SupportModal)
Vue.component('editModal', EditAddressModal)
Vue.component('refundModal', RefundModal)
Vue.component('refundModal2', RefundModal2)
Vue.component('refundModal3', RefundModal3)
Vue.component('AvisCreationModal', AvisCreationModal)
Vue.component('ordersTable', OrdersTable)
Vue.component('clickCollectTable', ClickCollectTable)
Vue.component('orderNotes', OrderNotes)
Vue.component('labelHistory', LabelHistory)
Vue.component('storeHistory', StoreHistory)
Vue.component('editCompany', EditCompany)
Vue.component('storesTable', StoresTable)
Vue.component('usersTable', UsersTable)
Vue.component('extension', ErpExtension)
Vue.component('createStore', StoreCreate)
Vue.component('editStore', StoreEdit)
Vue.component('lineChart', LineChart)
Vue.component('TopBrandsChart', TopBrandsChart)
Vue.component('TopCategoriesChart', TopCategoriesChart)
Vue.component('TopColorsChart', TopColorsChart)
Vue.component('TopPricesChart', TopPricesChart)
Vue.component('TopProductsChart', TopProductsChart)
Vue.component('TopSeasonsChart', TopSeasonsChart)
Vue.component('PriceChart', PriceBarChart)
Vue.component('doughnutChart', DoughnutChart)
Vue.component('MultiLineChart', MultipleLineChart)
Vue.component('Multiselect', Multiselect)
Vue.component('salesReport', SalesReport)
Vue.component('statsReport', StatsReport)
Vue.component('statsDescription', StatsDescription)
Vue.component('salesReportChart', SalesReportChart)
Vue.component('marketplaceStats', MarketplaceStats)
Vue.component('performanceBox', PerformanceBoxComponent)
Vue.component('erpExtension', ERPExtension)
Vue.component('paymentBox', PaymentStoresBoxComponent)
Vue.component('clickCollectBox', ClickAndCollectBoxComponent)
Vue.component('dateRangePicker', DateRangePicker)
Vue.component('priceInfoModal', PriceInfoModal)
Vue.component('priceBox', PriceBox)
Vue.component('priceBoxMp', PriceBoxMpComponent)
Vue.component('BulkUpdateModal', BulkUpdateModal)
Vue.component('MonitoringRow', MonitoringRow)
Vue.component('LabelRow', LabelRow)
Vue.component('ProductChannel', ProductRow)
Vue.component('sap-doc-history-modal', SapDocHistoryModal)
Vue.component('PaymentHistory', PaymentHistory)
Vue.component('SapSalesChannelConfigModal', SapSalesChannelConfigModal)
Vue.component('StoreRow', StoreRow)
Vue.component('TimeTabs', TimeTabs)
Vue.component('ChannelsFilter', ChannelsfFilter)
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(Vue2Editor)
Vue.use(VueAnimateNumber)
Vue.use(VeeValidate, {fieldsBagName: 'veeFields', events: 'input|blur'})
Vue.mixin({
  methods: {
    formatBarDatasets: arr => {
      let newDatasets = []
      let colors = []
      arr.forEach(d => {
        d.data.forEach(ds => {
          colors.push(`rgb(${Math.round(Math.random() * 255)}, ${Math.round(Math.random() * 255)}, ${Math.round(Math.random() * 255)})`)
        })
        d.borderColor = colors
        d.backgroundColor = colors
        newDatasets.push(d)
      })
      return newDatasets
    }
  }
})

router.beforeEach((to, from, next) => {
  store.commit('initialiseStore')
  if (to.meta.auth && !store.getters.loggedInStatus) {
    next({
      path: '/'
    })
  }
  if (to.path === '/' && store.getters.loggedInStatus) {
    next({
      path: '/home'
    })
  }
  next()
})
store.subscribe((mutation, state) => {
	localStorage.setItem('store', JSON.stringify(state))
})

new Vue({
  el: '#app',
  router,
  store,
	beforeCreate () {
		this.$store.commit('initialiseStore');
	},
  components: { App },
  template: '<App/>'
})

function getURI () {
  //return 'https://a49hlxnr50.execute-api.eu-central-1.amazonaws.com/Prod/v1/'
  let productionURLs = ['cs.qb-schuhe.de', 'qb-schuhe.de', 'qualibet-schuhe.de', 'qbschuhe.de', 'www.qb-schuhe.de', 'www.qualibet-schuhe.de', 'www.qbschuhe.de', 'myplace.schuhe.de']
  if ((productionURLs.indexOf(window.location.hostname)) !== -1) {
    // return 'https://cs-backend.qb-schuhe.de/v1/'
    return 'https://cs-lambda.qb-schuhe.de/v1/'
  } else if (window.location.hostname === 'localhost' || window.location.hostname === 'qualibet.local' || window.location.hostname === 'cs-frontend.test') {
    return 'http://cs-backend.test/v1/'
  } else if (window.location.hostname === 'cs.staging-qb.de') {
    //return 'https://cs-backend.staging-qb.de/v1/'
    return 'https://a49hlxnr50.execute-api.eu-central-1.amazonaws.com/Prod/v1/'
  }
}



// WEBPACK FOOTER //
// ./src/main.js